<script>
import MembershipCard from '@school/components/MembershipCard.vue';

const ACTIVE_STATUSES = ['active', 'cancel_at_period_end'];

export default {
  name: 'MembershipSections',
  components: { MembershipCard },
  props: {
    memberships: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    activeMemberships() {
      return this.sortMemberships(
        this.memberships.filter((membership) => ACTIVE_STATUSES.includes(membership.status)),
      );
    },
    archivedMemberships() {
      return this.sortMemberships(
        this.memberships.filter((membership) => !ACTIVE_STATUSES.includes(membership.status)),
      );
    },
    hasActive() {
      return this.activeMemberships.length > 0;
    },
  },

  methods: {
    sortMemberships(list) {
      const statusPriority = {
        active: 0,
        cancel_at_period_end: 1,
        expired: 2,
        canceled: 3,
      };

      return [...list].sort((a, b) => {
        const priorityA = statusPriority[a.status] ?? 99;
        const priorityB = statusPriority[b.status] ?? 99;

        if (priorityA === priorityB) {
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        }

        return priorityA - priorityB;
      });
    },
    handleCancel(...args) {
      this.$emit('cancel', ...args);
    },
    handleReactivate(...args) {
      this.$emit('reactivate', ...args);
    },
    handleRejoin(...args) {
      this.$emit('rejoin', ...args);
    },

  },
  i18n: {
    messages: {
      en: {
        active_heading: 'Subscriptions',
        archived_heading: 'History',
        empty_active: 'No active subscriptions yet.',

      },
      fr: {
        active_heading: 'Abonnements',
        archived_heading: 'Historique',
        empty_active: 'Aucun abonnement actif pour le moment.',

      },
    },
  },
};
</script>

<template>
  <div>
    <div v-if="hasActive" class="mb-5">
      <h3 class="title is-6 mb-3">
{{ $t('active_heading') }}
</h3>
      <MembershipCard
        v-for="membership in activeMemberships"
        :key="membership.id || membership.uuid"
        :membership="membership"
        @cancel="handleCancel"
        @reactivate="handleReactivate"
        @rejoin="handleRejoin"
      />
    </div>
    <div v-else class="notification is-light has-text-centered py-5 mb-5">
      {{ $t('empty_active') }}
    </div>

    <div v-if="archivedMemberships.length" class="archived-memberships">
      <h3 class="title is-6 mb-3">
{{ $t('archived_heading') }}
</h3>
      <MembershipCard
        v-for="membership in archivedMemberships"
        :key="membership.id || membership.uuid"
        :membership="membership"
        @cancel="handleCancel"
        @reactivate="handleReactivate"
        @rejoin="handleRejoin"
      />
    </div>
  </div>
</template>
